import { forwardRef, Ref, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGSVGElement>

const LinkedinGrey = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => (
  <svg
    ref={ref}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.84372 6.77096C9.05935 6.5122 9.23186 6.25345 9.49062 6.03781C10.1806 5.39091 11.0001 5.0459 11.992 5.0459C12.5095 5.0459 13.0701 5.08902 13.5445 5.2184C14.7089 5.56342 15.399 6.38282 15.744 7.50412C16.0027 8.36665 16.0459 9.22918 16.0459 10.1348C16.0459 11.9893 16.0459 13.8869 16.0459 15.7413C16.0459 15.9138 16.0027 15.9569 15.8302 15.9569C14.8814 15.9569 13.8895 15.9569 12.9408 15.9569C12.7682 15.9569 12.7251 15.9138 12.7251 15.7413C12.7251 13.9731 12.7251 12.2049 12.7251 10.4367C12.7251 10.0055 12.682 9.53107 12.5526 9.0998C12.337 8.32352 11.7332 7.89226 10.9138 7.93538C9.79251 7.97851 9.18873 8.53916 9.01622 9.70358C8.9731 9.96234 8.9731 10.2642 8.9731 10.523C8.9731 12.2481 8.9731 13.9731 8.9731 15.6982C8.9731 15.8707 8.92997 15.9138 8.75746 15.9138C7.80868 15.9138 6.81676 15.9138 5.86798 15.9138C5.69547 15.9138 5.65234 15.8707 5.65234 15.6982C5.65234 12.2912 5.65234 8.88417 5.65234 5.43404C5.65234 5.26153 5.69547 5.2184 5.86798 5.2184C6.77364 5.2184 7.72242 5.2184 8.62808 5.2184C8.80059 5.2184 8.84372 5.26153 8.84372 5.43404C8.84372 5.95156 8.84372 6.3397 8.84372 6.77096Z"
      fill="#666666"
    />
    <path
      d="M3.57872 10.6522C3.57872 12.3342 3.57872 14.0161 3.57872 15.7412C3.57872 15.9137 3.5356 15.9999 3.31996 15.9999C2.37118 15.9999 1.37926 15.9999 0.430477 15.9999C0.25797 15.9999 0.214844 15.9568 0.214844 15.7843C0.214844 12.3773 0.214844 8.92717 0.214844 5.52016C0.214844 5.39078 0.257971 5.34766 0.387351 5.34766C1.37926 5.34766 2.32805 5.34766 3.31996 5.34766C3.49247 5.34766 3.5356 5.43391 3.5356 5.56329C3.57872 7.24523 3.57872 8.9703 3.57872 10.6522Z"
      fill="#666666"
    />
    <path
      d="M3.83827 1.9407C3.83827 3.01887 2.97574 3.8814 1.89757 3.8814C0.862534 3.83827 0 2.97574 0 1.9407C0 0.862533 0.862533 0 1.9407 0C2.97574 0 3.83827 0.862533 3.83827 1.9407Z"
      fill="#666666"
    />
  </svg>
))

export default LinkedinGrey
